import { render } from "./Layout.vue?vue&type=template&id=049409a2&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=049409a2&scoped=true&lang=css"

import exportComponent from "/var/www/atc.vacc.cz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049409a2"]])

export default __exports__